import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actions from './store/actions/index';

import Spinner from './UI/Spinner/Spinner';
import Layout from './containers/Layout/Layout';

import Search from './containers/Search/Search';

import MdmSearch from './containers/MDMSearch/MdmSearch';
import AddAccount from './containers/AddAccount/AddAccount';
import MdmMember from './components/MdmMember/MdmMember';
import DisableAccounts from './containers/BulkDisable/DisableAccounts';
import ReportingSearch from './containers/Reporting/ReportingSearch';
import ServiceNowContainer from './containers/ServiceNow/ServiceNow';

import Logout from './components/Logout/Logout';
import Error from './components/Error/Error';
import Member from './containers/Member/Member';
import AddEligibility from './containers/Member/AddEligibility/AddEligibiity';
import ModifyEligibility from './containers/Member/ModifyEligibility/ModifyEligibility';
import AdvanceSearch from './containers/Search/AdvanceSearch';
import BrowserUpdate from './BrowserUpdate';

import IdleTimer from 'react-idle-timer';
import TimeoutModal from './UI/Modal/TimeoutModal';
import IdentityProofSessionModal from './UI/Modal/IdentityProofSessionModal';
import {SESSION_READONLYUSER, SESSION_SUPERUSER, SESSION_USERTYPE, TIMEOUT_PERIOD, WARNING_TIMEOUT_PERIOD, NOACCESS_ERROR_MESSAGE, SESSION_BASELINEAGENT, SESSION_SUPERVISORUSER, SESSION_TIER1USER} from '../src/shared/Constants';
import ActivityLogForm from './containers/ActivityLog/ActivityLogForm';
export class App extends Component {

    state = {
        browserVersionCheck: ""
    }

    componentWillMount(){
        let browserVersionCheck = <BrowserUpdate></BrowserUpdate>
        this.setState({browserVersion: browserVersionCheck});
    }

    constructor(props) {
        super(props);
        this.idleTimer = null;
        this.handleOnIdle = this.handleOnIdle.bind(this);
        this.handleStayLoggedIn = this.handleStayLoggedIn.bind(this);
        this.logoutTimer = null;
    }

    state ={
        isIdle:false
    }

    handleLogout () {
        this.setState({isIdle : true});
    }

    handleOnIdle (event) {
        this.toggleModalHandler();
        this.logoutTimer = setTimeout(() => {
            this.handleLogout();
        }, WARNING_TIMEOUT_PERIOD);
    }
    componentDidMount () {
        if(window.location.pathname!=="/logout" && window.location.pathname!=="/error"){
            this.props.fetchUser();
        }
    }

    toggleModalHandler () {
        this.setState({showModal: !this.state.showModal});
    }

    handleStayLoggedIn () {
        if (this.logoutTimer) {
          clearTimeout(this.logoutTimer);
          this.logoutTimer = null;
        }
        this.idleTimer.reset();
        this.toggleModalHandler();
    }

  render() {
    // console.log("[App] env ", process.env.ADMIN_SERVICE_HOST, process.env.ADMIN_SERVICE_BASE_PATH)
    //   console.log("[App] render: ", this.props.user, this.props.loading);

    let app = <Spinner/>;
    let browserPopUp = this.state.browserVersion;

    if(this.state.isIdle){
        this.props.onUserLogout();
    }

      if(window.location.pathname==="/logout") {
          app = (
              <div>
                  <Route path="/logout" component={Logout}/>
              </div>
          );
          
      }else if(window.location.pathname==="/error"){
            app = (
                <div>
                    <Route path="/error" component={() => (<Error message={NOACCESS_ERROR_MESSAGE} />)}/>
                </div>
            );
      } else if(this.props.user && this.props.user.loggedIn && !this.props.loading) {
        app = (
            <div>
                {browserPopUp}
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    timeout={TIMEOUT_PERIOD}
                    onIdle={this.handleOnIdle}
                    stopOnIdle={true}
                />
                <TimeoutModal
                    showModal={this.state.showModal}
                    togglePopup={this.toggleModalHandler}
                    handleStayLoggedIn={this.handleStayLoggedIn}
                />
                <IdentityProofSessionModal />
                <Layout>
                    <Switch>
                        {
                            (localStorage.getItem(SESSION_USERTYPE) !== SESSION_BASELINEAGENT) &&
                            <Route path="/search/advance" exact component={AdvanceSearch}/>
                        }
                        {
                            (localStorage.getItem(SESSION_USERTYPE) !== SESSION_BASELINEAGENT && localStorage.getItem(SESSION_USERTYPE) !== SESSION_READONLYUSER && this.props.user.userType !== SESSION_READONLYUSER) &&
                            <Route path="/search/mdm" exact component={MdmSearch}/>
                        }
                        <Route path="/search" exact component={Search}/>
                        {
                            (localStorage.getItem(SESSION_USERTYPE)===SESSION_SUPERUSER || localStorage.getItem(SESSION_USERTYPE)===SESSION_SUPERVISORUSER ||
                        localStorage.getItem(SESSION_USERTYPE)===SESSION_TIER1USER)  && 
                            <Route path="/search/activity" exact component={ActivityLogForm}/>
                        }
                        {
                            (localStorage.getItem(SESSION_USERTYPE)===SESSION_SUPERUSER) &&
                            <Route path="/account/add" exact component={AddAccount}/>
                        }
                        <Route path={this.props.user.userType === SESSION_SUPERUSER && this.props.user.disableUser ? "/account/disable" : "/search"} exact component={this.props.user.userType === SESSION_SUPERUSER && this.props.user.disableUser ? DisableAccounts : Search}/>
                        <Route path="/member/:uuid/:idType" component={Member}/>
                        <Route path="/mdmMember" component={MdmMember}/>
                        <Route path="/addEligibility/:uuid" component={AddEligibility} />
                        <Route path="/modifyEligibility" component={ModifyEligibility} />
                        {
                            (localStorage.getItem(SESSION_USERTYPE)===SESSION_SUPERUSER) && 
                            <Route path="/reporting" exact component={ReportingSearch}/>
                        }
                        {
                            (localStorage.getItem(SESSION_USERTYPE)===SESSION_SUPERUSER) && 
                            <Route path="/serviceNow" exact component={ServiceNowContainer}/>
                        }
                        <Redirect from="/" to="/search"/>
                    </Switch>
                </Layout>
            </div>
        );
    } else if((!this.props.user || !this.props.user.loggedIn) && !this.props.loading) {
        app = <p>Unauthorized user!</p>;

    }

    return app;
  }
}

export const mapStateToProps = state => {
    return {
        user: state.usr.user,
        loading: state.usr.loading
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        fetchUser: () => dispatch(actions.fetchUser()),
        onUserLogout: () => dispatch(actions.logoutUser())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);